import React from "react";
import stylesLess from "./index.module.less";
import { AppContext } from "contexts/app";
import XtInput from "components/Xt/Input";
import XtSvg from "components/Xt/Svg";

export default React.forwardRef(function FormItemInput(props, ref) {
  const [appState, appDispatch] = React.useContext(AppContext);
  const {
    isErr,
    value,
    maxLength = 128,
    autoComplete = "new-password",
    disabled,
    onInput,
    onFocus,
    onBlur,
    suffix,
    noCloseBtn,
    ...rest
  } = props;

  const [state_isFocus, setState_isFocus] = React.useState(false);

  const refInput = React.useRef();

  const handleInput = (val) => {
    onInput && onInput(val ? val.trim() : val);
  };
  const handleInputFocus = (e) => {
    // console.log("handleInputFocus");
    setState_isFocus(true);
    onFocus && onFocus(e);
  };
  const handleInputBlur = (e) => {
    // console.log("handleInputBlur");
    setState_isFocus(false);
    onBlur && onBlur(e);
  };

  const handleClear = () => {
    onInput && onInput("");
    refInput.current.focus();
  };

  const classList = [stylesLess.main, appState.isDark ? "dark" : "light"];
  isErr && classList.push("err");
  state_isFocus && classList.push("atv");

  React.useImperativeHandle(ref, () => ({
    inputEl: refInput.current,
  }));

  return (
    <div className={`${classList.join(" ")}`}>
      <XtInput
        ref={refInput}
        value={value}
        autoComplete={autoComplete}
        maxLength={maxLength}
        disabled={disabled}
        onInput={handleInput}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        {...rest}
      />
      {(value || value === 0) && !noCloseBtn && (
        <button
          className="btntxt ico"
          disabled={disabled}
          onClick={handleClear}
        >
          <XtSvg icon={"error"} />
        </button>
      )}
      {suffix}
    </div>
  );
});
